module.exports = __webpack_public_path__ + "static/media/icon-guide.06e30d7c.svg";